import React from 'react';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
      theme.palette.mode === 'light'
        ? theme.palette.grey[100]
        : theme.palette.grey[800];
    return {
      backgroundColor,
      height: theme.spacing(3),
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightRegular,
      '&:hover, &:focus': {
        backgroundColor: emphasize(backgroundColor, 0.06),
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: emphasize(backgroundColor, 0.12),
      },
    };
  }); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591
  
export default function PagePath({setp1,setp2,setp3}) {
  let navigate = useNavigate();
    const handlePerOrder = () => {
        navigate("/");
    }
  return (
    <div>
        <div role="presentation" style={{ padding:"1rem 0"}} >
        <Breadcrumbs aria-label="breadcrumb">
          <StyledBreadcrumb
            onClick={handlePerOrder} 
            component="a"
            href="#"
            label="Home"
            icon={<HomeIcon fontSize="small" />}
          />
          {setp1 && <StyledBreadcrumb component="a" href="" label={setp1} />}
          {setp2 && <StyledBreadcrumb component="a" href="" label={setp2} />}
          {setp3 && <StyledBreadcrumb component="a" href="" label={setp3} />}
        </Breadcrumbs>
      </div>
    </div>
  )
}
